import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { Booths } from "./pages/Booths";
import { Configurator } from "./pages/Configurator";
import { Exhibitions } from "./pages/Exhibitions";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Navbar from "./organisms/Navbar";
import { SceneEditorAppWrapper } from "oc-scene-editor/ui/SceneEditorAppWrapper";
import Footer from "./organisms/Footer";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import RobotoFont from "./RobotoFont";

function MesseRouter() {
  const BREAKPOINTS = {
    xs: 0,
    sm: 768,
    md: 960,
    lg: 1280,
    xl: 1920
  };

  const breakpointsFull = {
    breakpoints: createBreakpoints({
      values: BREAKPOINTS
    })
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: `#${APP.metadata.Basis[0].PrimaryColor.getHexString()}`,
      },
      secondary: {
        main: "#3A415A",
      },
      white: {
        main: "#fff",
      },
      danger: {
        main: "#C91113",
      },
      black: {
        main: "#000",
      },
      grey: {
        main: "#939599",
      },
    },
    typography: {
      allVariants: {
        fontFamily: ["Noto Sans TC"].join(","),
      }
    },
    zDepthShadows: "none",
    breakpointsFull
  });

  // Todo fix messed up cfg/configurator CSS coming from Wirtschaftswunder via JS as whole router div warping would need refactor (only configurator should have all this position absolute styles)
  if (window.location.href.indexOf('configurator') !== -1) {
    $('body').css('overflow', 'hidden');
  } else {
    $('body').css('overflow', 'auto');
  }

  return (
    <>
      <SceneEditorAppWrapper position="right" sceneNode={APP.sceneNode} isAdmin={APP.settings.userRole === "admin"}>
        <RobotoFont />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Switch>
            <Route exact path="/">
              <Redirect to="/exhibitions" />
            </Route>
            <Route path="/exhibitions">
              <Navbar />
              <Exhibitions />
              <Footer />
            </Route>
            <Route path="/:exhibitionId/booths">
              <Navbar />
              <Booths />
              <Footer />
            </Route>

            <Route path="/:exhibitionId/:boothId/configurator/:code?">
              <Navbar />
              <Configurator />
            </Route>

            <Route exact path="*" exact={true}>
              <Redirect to="/exhibitions" />
            </Route>
          </Switch>
        </ThemeProvider>
      </SceneEditorAppWrapper>
    </>
  );
}

export default withRouter(MesseRouter);
